"use client";

import Header from "./Header/index";
import Footer from "./Footer/index";
import { useLayout } from "@/context/LayoutContext";
import { ScrollContext } from "@/context/ScrollContext";

import { pageService } from "@/services/pageServices";
import { MainMenus } from "@/types/common";
import React,{ useEffect, useState, useRef } from "react";
import ScrollToTop from "./ScrollToTop";
// import Head from "next/head";
import { ScrollToTopOnRouteChange } from "./ScrollToTopOnRouteChange";
import TopLoader from "./TopLoader";

export default function Layout({
  children,
  initialMenus,
  hostname,
}: {
  children: React.ReactNode;
  initialMenus?: MainMenus | null;
  hostname?: string;
}) {
  const { showHeader, showFooter } = useLayout();
  const scrollRef = useRef<HTMLDivElement>(null);
  const [menus, setMenus] = useState<MainMenus | null>(initialMenus || null);

  useEffect(() => {
    if (initialMenus) {
      return;
    }
    const fetchMenus = async () => {
      try {
        const response = await pageService.getMenus();
        if (response && response.data) {
          
          setMenus(response.data as MainMenus);
        } else {
          // If API doesn't return valid data, use dummy data
          // setMenus(getDummyMenuData());
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
        // Use dummy data on error
        // setMenus(getDummyMenuData());
      }
    };

    fetchMenus();
  }, [initialMenus]);
  
  // Function to generate dummy menu data following the MainMenus structure
 
  
  return (
    <ScrollContext.Provider value={scrollRef}>
      <TopLoader />
      <div ref={scrollRef} className="min-h-screen h-screen relative overflow-y-auto scroll-smooth">
        <ScrollToTopOnRouteChange scrollRef={scrollRef} />
        {showHeader && menus && <Header menuItems={menus} hostname={hostname} />}
        <main className="bg-background min-h-[100vh]">{children}
          <ScrollToTop scrollRef={scrollRef} />
        </main>
        {showFooter && menus && <Footer menuItems={menus} />}
      </div>
    </ScrollContext.Provider>
  );
}
